/**
 * 身份验证信息
 *
 */
export const useAuthenticationStore = defineStore('authentication', () => {
  // state
  const refreshing = ref(false);
  const alertToLogin = ref(false);

  // 方法

  /**
   * 设置刷新状态
   * @param {*} refresh
   */
  function setRefreshing(refresh) {
    refreshing.value = refresh;
  }
  /**
   * 设置登录提示信息
   * @param {*} alert
   */
  function setAlertToLogin(alert) {
    alertToLogin.value = alert;
  }

  return {
    refreshing,
    alertToLogin,

    setRefreshing,
    setAlertToLogin,
  };
});
